import { HostEnvironment } from '@makemydeal/dr-shared-ui-utils';

import type { DDJEnvironment } from './types';

export const DDJ_SCRIPT_ID = 'ddj-pbc-url';

export const DDJ_PRELOADER_ID = 'ddj-preloader-container';

export const DEFAULT_PARTNER_ID = 'MMD';

// The DDJ loader assets are served from a separate CloudFront distribution per
// environment, and each distribution only allows the origins for that
// environment. Loading the non-prod loader from prod therefore fails CORS, so
// the URL has to track the environment. The host app config does not currently
// surface these URLs, so we hardcode them; once the BFF/config exposes the
// loader URL, prefer reading from state and use this only as a fallback.
export const DDJ_SOURCE_URLS: Record<DDJEnvironment, string> = {
    dev: 'https://fni-static-np.dealertrack.com/apps/digital-dealjacket-ui/versions/beta/appLoader.js',
    uat: 'https://fni-static-np.dealertrack.com/apps/digital-dealjacket-ui/versions/rc/appLoader.js',
    prod: 'https://fni-static.dealertrack.com/apps/digital-dealjacket-ui/versions/latest/appLoader.js'
};

// Maps the host environment to the `env` value the DDJ PBC expects. Typing the
// values as DDJEnvironment keeps this map and DDJ_SOURCE_URLS in lockstep, so
// every host environment is guaranteed to resolve to a real loader URL.
export const DDJ_ENV_BY_HOST: Record<HostEnvironment, DDJEnvironment> = {
    [HostEnvironment.Dev]: 'dev',
    [HostEnvironment.Dev2]: 'dev',
    [HostEnvironment.Local]: 'dev',
    [HostEnvironment.QA]: 'uat',
    [HostEnvironment.DarkProd]: 'prod',
    [HostEnvironment.UAT]: 'uat',
    [HostEnvironment.Prod]: 'prod',
    [HostEnvironment.None]: 'uat',
    [HostEnvironment.Unknown]: 'uat'
};
